import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { variant, compose, space, color, border, height } from 'styled-system';
import styled from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, radius, color as color$1 } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { forwardRef } from '../../system/forwardRef.es.js';
import Button from '../Button/Button.es.js';
import { useModalContext } from './ModalContext.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var styles = variant({
  prop: "size",
  variants: {
    sm: {
      px: [null, "md", "lg"],
      py: [null, "md", "md"]
    },
    md: {
      px: [null, "md", "xxl"],
      py: [null, "md", "lg"]
    },
    lg: {
      px: [null, "md", "xxl"],
      py: [null, "md", "lg"]
    }
  }
});
var ModalContinueButton = forwardRef(function (_a, ref) {
  var _b = _a,
      _b$kind = _b.kind,
      kind = _b$kind === void 0 ? "solid" : _b$kind,
      _b$variant = _b.variant,
      variant2 = _b$variant === void 0 ? "primary" : _b$variant,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      props = __objRest(_b, ["kind", "variant", "size"]);

  return (
    /* @__PURE__ */
    React.createElement(Button, __spreadValues({
      ref: ref,
      kind: kind,
      variant: variant2,
      size: size
    }, props))
  );
});
ModalContinueButton.displayName = "Modal.ContinueButton";
var ModalCancelButton = forwardRef(function (_c, ref) {
  var _d = _c,
      _d$kind = _d.kind,
      kind = _d$kind === void 0 ? "solid" : _d$kind,
      _d$variant = _d.variant,
      variant2 = _d$variant === void 0 ? "subtle" : _d$variant,
      _d$size = _d.size,
      size = _d$size === void 0 ? "md" : _d$size,
      props = __objRest(_d, ["kind", "variant", "size"]);

  return (
    /* @__PURE__ */
    React.createElement(Button, __spreadValues({
      ref: ref,
      kind: kind,
      variant: variant2,
      size: size
    }, props))
  );
});
ModalCancelButton.displayName = "Modal.CancelButton";
var StyledModalFooter = styled("footer").withConfig({
  componentId: "sc-1lmcj4v-0"
})(["display:flex;flex:0 1 auto;justify-content:flex-end;min-height:min-content;background-color:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";", ";", ";"], themeMode({
  dark: color$1("neutral.900"),
  light: color$1("neutral.0")
}), radius("base"), radius("base"), styles, compose(space, color, border, height));
var ModalFooter = forwardRef(function (_e, ref) {
  var _f = _e,
      children = _f.children,
      props = __objRest(_f, ["children"]);

  var _useModalContext = useModalContext(),
      size = _useModalContext.size;

  return (
    /* @__PURE__ */
    React.createElement(StyledModalFooter, __spreadValues({
      ref: ref,
      size: size
    }, props), children)
  );
});
ModalFooter.displayName = "Modal.Footer";
export { ModalCancelButton, ModalContinueButton, ModalFooter };